var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "message-box"
  }, [_c("div", [_c("div", {
    staticClass: "message-content"
  }, [_c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.renderMessage)
    }
  })])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };